import { render, staticRenderFns } from "./TripDetails.vue?vue&type=template&id=ac2e7524&scoped=true"
import script from "./TripDetails.vue?vue&type=script&lang=js"
export * from "./TripDetails.vue?vue&type=script&lang=js"
import style0 from "./TripDetails.vue?vue&type=style&index=0&id=ac2e7524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2e7524",
  null
  
)

export default component.exports